module.exports = __webpack_public_path__ + "media/images/illustrations/problem-solving-7ce57754bf1e2255a85d12af5288ac15.svg";